import React from "react"
import { Typography } from "@one-thd/sui-atomic-components";

export default function FieldLabel({title}) {
  return (
    <Typography weight="bold" variant="body-base">
      {title}
    </Typography>
  )
}